<template>
  <section
    class="mx-auto flex w-full max-w-396.75 flex-col px-5 lg:px-20.75 xl:px-39.5 2xl:px-0!"
  >
    <slot />
  </section>
</template>
